module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GT-7d3cd589d413139d8b001866caa790d3.png";